/**
 * Created by henian.xu on 2019/10/31.
 * 项目路由
 */
import { addPower, addRoutes, GlobalVar } from 'vmf';
import Api from '@/api';
import { ElementUI } from '@vmf/components';
import { getSocket } from '@/plugins/WebSocket';
import LoginPage from 'pages/user/Login';
import demoRoutes from './demo'; // 菜单布局组件的 数据

const { Loading } = ElementUI;
const MenuProps = { data: {} };

// 复用页面

addRoutes(
    [
        {
            path: '/',
            redirect: '/index',
        },
        {
            path: '/index',
            name: 'index',
            component: () => import('@/pages/index.vue'),
            meta: {
                title: '首页',
            },
        },
        {
            path: '/query',
            name: 'query',
            component: () => import('@/pages/query.vue'),
            meta: {
                title: '准考证列表',
            },
        },
        {
            path: '/login',
            name: 'login',
            component: LoginPage,
            meta: {
                title: '登录',
                isChoose: false,
            },
        },
    ],
    async () => {
        const socket = getSocket();
        if (socket) {
            socket.close();
        }
        console.log('初始路由数据开始', 111111);
        const loadingInstance = Loading.service({
            lock: true,
            text: '正在加载所需数据,请稍后...',
        });
        const jsons = await Promise.all([Api.Rs.User.menu(), Api.Rs.User.menuResource()]).finally(() => {
            loadingInstance.close();
        });
        MenuProps.data = jsons[0].data.data;
        addPower(jsons[1].data.data);
    },
);
if (GlobalVar.isDev) {
    addRoutes(demoRoutes);
}
